import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    flexGrow: 1,

    '& .step': {
      '&-circle': {
        '&-container': {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: '50%',
          background: theme.palette.custom.surface[3],
          color: theme.palette.text.hint,

          [theme.breakpoints.up('md')]: {
            width: theme.spacing(4),
            height: theme.spacing(4),
            marginRight: theme.spacing(1),
          },
          [theme.breakpoints.down('sm')]: {
            width: theme.spacing(3),
            height: theme.spacing(3),
            marginBottom: theme.spacing(1 / 2),
          },
        },
        '&-text': {
          lineHeight: 1,
        },
      },
      '&-name': {
        color: theme.palette.text.hint,
      },
      '&-container': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: theme.spacing(0, 3),

        [theme.breakpoints.down('sm')]: {
          flexDirection: 'column',
          padding: theme.spacing(1 / 2, 3, 0),
        },

        '&.active': {
          '& .step': {
            '&-circle-container': {
              background: theme.palette.primary.main,
              color: theme.palette.getContrastText(theme.palette.primary.main),
            },
            '&-name': {
              color: theme.palette.primary.main,
            },
          },
        },
        '&.completed': {
          '& .step': {
            '&-circle-container': {
              background: theme.palette.custom.feedback.positive,
              color: theme.palette.getContrastText(
                theme.palette.custom.feedback.positive,
              ),
            },
          },
        },
        '&.error': {
          '& .step': {
            '&-circle-container': {
              background: theme.palette.custom.feedback.warning,
              color: theme.palette.getContrastText(
                theme.palette.custom.feedback.warning,
              ),
            },
          },
        },
      },
    },
  },
}));

export default styles;
